import * as Case from 'case';
import { StepsHelperStepComponent } from '~contentful/components/steps-helper-step/steps-helper-step.component';
import { ActionModel } from '~contentful/models/actions/action.model';
import { ComponentModel } from '~contentful/models/components/component.model';
import { AssetModel } from '~contentful/models/core/asset.model';

export class StepsHelperStepModel extends ComponentModel {
  public readonly heading: string;
  public readonly subText: string;
  public readonly stepNumber: number;
  public readonly image: AssetModel;
  public readonly onClick: ActionModel;
  public readonly componentClass = StepsHelperStepComponent;

  public get contextLabel() {
    return this.parent.contextLabel + ' | Step ' + this.stepNumber + ' - ' + this.heading;
  }

  public get contextValue() {
    return Case.kebab(this.contextLabel);
  }
}
